import { stdObject } from "../../../../data/types/stdObject";
import { toPrice } from "../../../../utils/toPrice";

export const summaryData = ({
  t,
  salesSection,
  totalComm,
  preCashTotal,
  numCustomers,
}: stdObject) => [
  {
    NAME:
      t("p.numCustomers", { customers: t("c.CLI2").toLowerCase() }) +
      ": " +
      numCustomers,
    TOTAL: "",
  },
  {
    NAME: t("p.totalCharged"),
    TOTAL: toPrice(salesSection.results.totals.payTotal),
  },
  {
    NAME: t("p.commissions"),
    TOTAL: toPrice(-totalComm),
  },
  {
    NAME: t("p.pettyCash"),
    TOTAL: toPrice(preCashTotal),
  },
];
